/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "semantic-ui-react";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice.js";
import { selectViewingOlderVersion } from "../../slices/viewingOlderVersion/viewingOlderVersionSlice.js";
import ReferenceEntry from "../../datatypeComponents/ReferenceEntry.jsx";
import { loadNetEffectContributions, selectAllNetEffectContributions, selectNetEffectContributionsStatus } from "../../slices/netEffectContributions/netEffectContributionsSlice.js";

const saveChanges = async (setSaveChangesState, setChangeAvailableToSaveState, setReassignOutcomesModalState,
    dispatch, setTriggerReloadState, netEffectContributions, reassignOutcomesWorkState
) => {
    let revisedNetEffectContributions = JSON.parse(JSON.stringify(netEffectContributions));
    for (const section of revisedNetEffectContributions) {
        let key = section.id;
        if (reassignOutcomesWorkState[key]) {
            section.focus = reassignOutcomesWorkState[key];
        }
    }
    dispatch(loadNetEffectContributions({ netEffectContributions: revisedNetEffectContributions }));
    if (setTriggerReloadState) {
        console.log("setTriggerReloadState to true from ReassignOutcomes")
        setTriggerReloadState(true);
    }
    setSaveChangesState(false);
    setChangeAvailableToSaveState(false);
    setReassignOutcomesModalState(prevState => { return { ...prevState, modalOpen: false }; });
};

const ReassignOutcomesModal = ({ reassignOutcomesModalState,
    setReassignOutcomesModalState, setTriggerReloadState }) => {

    const dispatch = useDispatch();

    const netEffectContributions = useSelector(state => selectAllNetEffectContributions(state));
    const netEffectContributionsStatus = useSelector(selectNetEffectContributionsStatus);

    const [reassignOutcomesWorkState, setReassignOutcomesWorkState] = useState({});
    const [startingOutcomesWorkState, setStartingOutcomesWorkState] = useState({});
    const [saveChangesState, setSaveChangesState] = useState(false);
    const [changeAvailableToSaveState, setChangeAvailableToSaveState] = useState(false);

    useEffect(() => {
        let outcomeReferenceDictionary = {};
        if (netEffectContributionsStatus === "succeeded") {
            for (const section of netEffectContributions) {
                outcomeReferenceDictionary[section.id] = section.focus;
            }
            setReassignOutcomesWorkState(outcomeReferenceDictionary);
            setStartingOutcomesWorkState(outcomeReferenceDictionary);
        }
    }, [netEffectContributionsStatus]);

    useEffect(() => {
        if (JSON.stringify(reassignOutcomesWorkState) !== JSON.stringify(startingOutcomesWorkState)) {
            setChangeAvailableToSaveState(true);
        }
    }, [reassignOutcomesWorkState])

    useEffect(() => {
        if (saveChangesState === true && netEffectContributions &&
            setTriggerReloadState) {
            saveChanges(setSaveChangesState, setChangeAvailableToSaveState, setReassignOutcomesModalState,
                dispatch, setTriggerReloadState, netEffectContributions, reassignOutcomesWorkState);
        }
    }, [saveChangesState]);

    let modalContent = <div style={{
        paddingTop: "0px", paddingLeft: "20px", paddingRight: "20px",
        paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
    }}>
        <span style={{
            position: "absolute", backgroundColor: "#FFFFFF", width: "calc(90vw - 38px)", zIndex: 100,
            paddingTop: "6px", paddingBottom: "6px"
        }} >
            <Button style={{
                color: changeAvailableToSaveState ? "#FFFFFF" : "#000000",
                width: "230px", float: "left"
            }}
                className="formButton" disabled={saveChangesState}
                content="Save Changes" positive={changeAvailableToSaveState}
                onClick={() => {
                    setSaveChangesState(true);
                }}
            />
            &nbsp;&nbsp;&nbsp;
            <Button style={{ color: "#000000", width: "180px", float: "right" }}
                className="formButton"
                content="Close Window"
                onClick={() => {
                    setReassignOutcomesModalState(prevState => { return { ...prevState, modalOpen: false }; });
                }}
            />
        </span>
        <br /><br /><br />
        <div>
            {(reassignOutcomesWorkState && Object.keys(reassignOutcomesWorkState).length > 0) &&
                Object.keys(reassignOutcomesWorkState).map((itemNumber, itemKey) => {
                    return <div key={itemKey}>
                        <h3>Set or create the structured Outcome Definition</h3>
                        <br />
                        <ReferenceEntry elementName={itemNumber} enableCreation={true}
                            fieldLabel='OutcomeDefinition (Resource Reference)'
                            referencedResourceTypes={['EvidenceVariable']}
                            startingResourceType="EvidenceVariable"
                            selectProfile={["VariableDefinition", "DichotomousIntendedOutcome"]}
                            startingValue={reassignOutcomesWorkState[itemNumber]}
                            setResourceState={setReassignOutcomesWorkState} />
                        <br />
                    </div>
                })
            }
        </div>
        <br /><br />
    </div>;

    return <>
        <Modal
            style={{ padding: "0px", margin: "0px" }}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            open={reassignOutcomesModalState?.modalOpen}
            centered={false}
            content={modalContent}
            className="viewmywork"
        />
    </>
}

const ReassignOutcomes = ({ setTriggerReloadState }) => {
    const apiToken = useSelector(selectCurrentUserApiToken);
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));

    const [reassignOutcomesModalState, setReassignOutcomesModalState] = useState({ "modalOpen": false });

    return <>
        {reassignOutcomesModalState &&
            <>
                {reassignOutcomesModalState.modalOpen &&
                    <ReassignOutcomesModal
                        reassignOutcomesModalState={reassignOutcomesModalState}
                        setReassignOutcomesModalState={setReassignOutcomesModalState}
                        setTriggerReloadState={setTriggerReloadState} />
                }
                <span>
                    <Button className="formButton" style={{ color: "#000000", width: "220px" }}
                        content="Reassign Outcomes"
                        onClick={() => {
                            if (apiToken) {
                                setReassignOutcomesModalState({ "modalOpen": true });
                            } else {
                                alert("Please login to use this function.");
                            }
                        }}
                        disabled={viewingOlderVersion}
                    />
                    &nbsp;&nbsp;&nbsp;
                    <>
                        Change the assigned Resource for any of the outcomes, e.g. to use DichotomousIntendedOutcome for shared use.
                    </>
                </span>
            </>}
    </>
};

export default ReassignOutcomes;